"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatStringDate = void 0;
var _format = _interopRequireDefault(require("date-fns/format"));
var formatStringDate = function formatStringDate(dateToFormat) {
  var formattedDate = (0, _format.default)(dateToFormat, 'yyyy-MM-dd');
  var formattedTime = (0, _format.default)(dateToFormat, 'HH:mm:ss');
  return "".concat(formattedDate, "T").concat(formattedTime);
};
exports.formatStringDate = formatStringDate;